import React from "react";
import { Icon, Paragraph } from "@tvg/design-system/web";
import {
  DescriptionContainer,
  TooltipTrigger,
  TagContainer
} from "./styled-components";

interface Props {
  label: string;
  description: string;
  qaLabel?: string;
}

export const TooltipTag = ({
  label,
  description,
  qaLabel = "tag-tooltip"
}: Props) => (
  <TagContainer data-qa-label={qaLabel}>
    <TooltipTrigger
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <Icon
        size="s"
        lineColor="--fd-colors-system-info-content-accent"
        name="info"
      />
      <DescriptionContainer>{description}</DescriptionContainer>
    </TooltipTrigger>
    <Paragraph
      fontSize="--fd-font-sizes-font-size-040"
      color="--fd-colors-system-info-content-accent"
      textTransform="uppercase"
      fontStyle="normal"
      fontFamily="condensedRegular"
      fontWeight="400"
      maxHeight="max-content"
    >
      {label}
    </Paragraph>
  </TagContainer>
);
